import { useEffect } from 'react';
import { useLayoutStore } from '@/stores/useLayoutStore';

export function useDisableLocationSelection(disable = true) {
  const setDisableLocationSelection = useLayoutStore(state => state.setDisableLocationSelection);
  
  useEffect(() => {
    // Set location selection state immediately
    setDisableLocationSelection(disable);
    
    // Clean up on unmount - enable location selection again
    return () => {
      setDisableLocationSelection(false);
    };
  }, [disable, setDisableLocationSelection]);
}

